import _pt from "prop-types";

function _objectWithoutPropertiesLoose(a, b) {
  if (null == a) return {};
  var c,
      d,
      e = {},
      f = Object.keys(a);

  for (d = 0; d < f.length; d++) {
    c = f[d], 0 <= b.indexOf(c) || (e[c] = a[c]);
  }

  return e;
}

function _assertThisInitialized(a) {
  if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}

function _inheritsLoose(a, b) {
  a.prototype = Object.create(b.prototype), a.prototype.constructor = a, a.__proto__ = b;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

import React from "react";
import vegaEmbed from "vega-embed";
import shallowEqual from "./utils/shallowEqual";
import getUniqueFieldNames from "./utils/getUniqueFieldNames";
import { NOOP } from "./constants";

var VegaEmbed =
/*#__PURE__*/
function (a) {
  function b() {
    for (var b, c = arguments.length, d = Array(c), e = 0; e < c; e++) {
      d[e] = arguments[e];
    }

    return b = a.call.apply(a, [this].concat(d)) || this, _defineProperty(_assertThisInitialized(b), "containerRef", React.createRef()), _defineProperty(_assertThisInitialized(b), "viewPromise", void 0), _defineProperty(_assertThisInitialized(b), "handleError", function (a) {
      var c = b.props.onError,
          d = void 0 === c ? NOOP : c;
      return d(a), console.warn(a), void 0;
    }), _defineProperty(_assertThisInitialized(b), "modifyView", function (a) {
      b.viewPromise && b.viewPromise.then(function (b) {
        return b && a(b), !0;
      }).catch(b.handleError);
    }), b;
  }

  _inheritsLoose(b, a);

  var c = b.prototype;
  return c.componentDidMount = function componentDidMount() {
    this.createView();
  }, c.componentDidUpdate = function componentDidUpdate(a) {
    var b = this,
        c = getUniqueFieldNames([this.props, a]);
    c.delete("className"), c.delete("style"), c.delete("signalListeners"), (Array.from(c).some(function (c) {
      return b.props[c] !== a[c];
    }) || !shallowEqual(this.props.signalListeners, a.signalListeners)) && (this.clearView(), this.createView());
  }, c.componentWillUnmount = function componentWillUnmount() {
    this.clearView();
  }, c.createView = function createView() {
    var a = this.props,
        b = a.spec,
        c = a.onNewView,
        d = a.onError,
        e = void 0 === d ? NOOP : d,
        f = a.signalListeners,
        g = void 0 === f ? {} : f,
        h = _objectWithoutPropertiesLoose(a, ["spec", "onNewView", "onError", "signalListeners"]);

    this.containerRef.current && (this.viewPromise = vegaEmbed(this.containerRef.current, b, h).then(function (a) {
      var b = a.view,
          c = Object.keys(g);
      return c.forEach(function (a) {
        try {
          b.addSignalListener(a, g[a]);
        } catch (a) {
          console.warn("Cannot add invalid signal handler >>", a);
        }
      }), 0 < c.length && b.run(), b;
    }).catch(this.handleError), c && this.modifyView(c));
  }, c.clearView = function clearView() {
    return this.modifyView(function (a) {
      a.finalize();
    }), this.viewPromise = void 0, this;
  }, c.render = function render() {
    var a = this.props,
        b = a.className,
        c = a.style;
    return (// Create the container Vega draws inside
      React.createElement("div", {
        ref: this.containerRef,
        className: b,
        style: c
      })
    );
  }, b;
}(React.PureComponent);

_defineProperty(VegaEmbed, "propTypes", {
  className: _pt.string,
  spec: _pt.any.isRequired,
  signalListeners: _pt.any,
  style: _pt.any,
  onNewView: _pt.any,
  onError: _pt.func
});

export { VegaEmbed as default };